import React, {Fragment} from "react";
import { useTheme } from "@material-ui/core/styles";
import {InputLabel, Icon, IconButton, Tooltip} from '@material-ui/core';
import __ from "lodash";
import Icons from "../icons";

const ActionsList = (props) => {
  const theme = useTheme();
  const {
    id,
    label,
    style,
    actions,
    className,
    actionProps={},
    width,
    record={},
  } = props;

  const baseStyle = {
    width,
    padding: "0px 10px",
  };

  const actionBaseStyle={
    marginTop: 8,
    color: theme.palette.secondary.main,
  }

  const actionPropsBase = {
    ...actionProps,
    style: {...actionBaseStyle, ...actionProps.style}
  }

  const renderActions = () => {
    if (actions && Array.isArray(actions)) {
      return (
        <Fragment>
          {actions.map((_action) => {
            let action = _action;
            const tooltip = action.tooltip

            const defaultStyle = {
              display: "inline-block"
            }
            const iconProps = {
              ...__.omit(action.iconProps, 'iconName', 'tooltip'),
              style: {...defaultStyle, ...action?.iconProps?.style},
              disabled: action?.disabled || action?.iconProps?.disabled,
              onClick: action?.iconProps?.onClick || action?.onClick
            }
            if (typeof action === "function") {
              action = action(record);
            }
            if (typeof action.render === "function") {
              return action.render(record, action);
            }
            if (tooltip) {
              return (
                <Tooltip title={tooltip} key={`${action.iconName}-actions`}>
                  <span>
                    <IconButton {...iconProps} >
                      <Icon>{action.iconName}</Icon>
                    </IconButton>
                  </span>
                </Tooltip>
              )
            }
            return (
              <IconButton {...iconProps} key={`${action.iconName}-actions`}>
                <Icons>{action.iconName}</Icons>
              </IconButton>
            )
          })}
        </Fragment>
      )
    }
    return <></>
  }

  return (
    <div className={className} style={{...baseStyle, ...style}} id={`${id}`}>
      {label?
        <InputLabel shrink id={`${id}-label`} key={`${id}-actions`} style={{position: "relative"}} >{label}</InputLabel>
        :<></>
      }
      <div id={`${id}-actions`} key={`${id}-actions`} {...actionPropsBase}>{renderActions()}</div>
    </div>
  );
}

export default ActionsList;
